export const DEFAULT_CURRENT_YEAR_FILTER_ON_STORAGE_KEY = "current_year_filter_on"

export function readCurrentYearFilterOn(storageKey = DEFAULT_CURRENT_YEAR_FILTER_ON_STORAGE_KEY) {
    try {
        const raw = window.localStorage.getItem(storageKey)
        if (raw == null) return true
        return String(raw).toLowerCase() === "true"
    } catch {
        return true
    }
}

export function writeCurrentYearFilterOn(nextOn, storageKey = DEFAULT_CURRENT_YEAR_FILTER_ON_STORAGE_KEY) {
    try {
        window.localStorage.setItem(storageKey, nextOn ? "true" : "false")
    } catch {
        // ignore (private mode / disabled storage)
    }
}

